import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-smesmb',
  templateUrl: './page-smesmb.component.html',
  styleUrls: ['./page-smesmb.component.css']
})

/**
 * page Blog-Detail-Two Component
 */
export class PageSmeSmbComponent implements OnInit {

      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = false;
  /**
   * Nav Light Class Add
   */
  navClass = 'nav-light';

  constructor() { }

  ngOnInit(): void {
  }


}
